<div class="row mx-0 intro-modal position-relative">
  <div class="pointer-cursor position-absolute right-align z-999 close-intro">
    <img src="assets/images/close-movie.svg" alt="" (click)="close()" height="24" width="24">
  </div>
  <div class="col-12 px-0 text-center">
    <p class="amatic-bold text-30">{{'Know what you’re learning' | translate}}</p>
    <p class="mulish-normal text-14 mt-4 color-5F5F5F">
      {{'Before getting started, Kindly take a look at some introductary videos to familiarize with the global expedition and sustainable development goals' | translate}}
    </p>
  </div>
  <div class="col-12 px-0">
    <div class="row mx-0 justify-content-center">
      <div class="col-12 col-lg-6" *ngFor="let video of videoList; let i = index ">
        <div class="intro-card h-100" [ngStyle]="{'background': (video.watched != 0)? '#F5FFF8': '#F5F5F5'}">
          <div>
            <p class="mulish-normal text-xxs color-5F5F5F">Video {{i+1}}:</p>
            <p class="mulish-normal text-16" style="line-height: 150%;">{{video.title | translate}}</p>
          </div>

          <div>
            <div class='video-wrapper'>
              <img [src]="video?.videoImg" alt="" class=" w-100 h-100">
            </div>
            <div class="mt-4 watch-button d-flex align-items-center justify-content-center" (click)="watchVideo(video)">
              <p *ngIf="video.watched != 0" class="mulish-bold text-13 mb-0">{{'Re watch Video'| translate | uppercase}}
              </p>
              <p *ngIf="video.watched == 0" class="mulish-bold text-13 mb-0">{{'Play video'| translate | uppercase}}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-4 ">
                <div class="intro-card">
                    <p class="mulish-normal text-xxs color-5F5F5F">Video 1:</p>
                    <p class="mulish-normal text-16" style="line-height: 150%;">What are Sustainable development goals?</p>
                    <div class='video-wrapper'> 
                        <img [src]="videoImg" alt="" class=" w-100 h-100">
                    </div>
                    <div class="mt-4 watch-button d-flex align-items-center justify-content-center">
                        <p class="mulish-bold text-13 mb-0">{{'Play video'| translate | uppercase}}</p>
                    </div>

                </div>

            </div>
            <div class="col-4">
                <div class="intro-card">
                    <p class="mulish-normal text-xxs color-5F5F5F">Video 1:</p>
                    <p class="mulish-normal text-16" style="line-height: 150%;">What are Sustainable development goals?</p>
                    <div class='video-wrapper'> 
                        <img [src]="videoImg" alt="" class=" w-100 h-100">
                    </div>
                    <div class="mt-4 watch-button d-flex align-items-center justify-content-center">
                        <p class="mulish-bold text-13 mb-0">{{'Play video'| translate | uppercase}}</p>
                    </div>

                </div>

            </div> -->

    </div>

  </div>
  <div *ngIf="!data.hideSkip" class="col-12 px-0 mt-4">
    <div class="flex-center cursor-pointer mulish-bold btn-block mb-3 color-5F5F5F" (click)="skipIntro()">
      <div> {{'Skip intro' | translate | uppercase}} </div>
      <mat-icon class="ml-3">arrow_right_alt</mat-icon>
    </div>

  </div>


</div>
